// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Featurecard-eh-features-QcEOS {
  width: 100%;
  background: #ffffff;
  padding: 48px 60px 72px;
}

.Featurecard-eh-features__container-tfAbN {
  margin: 0 auto;
  padding: 0 20px;
}

.Featurecard-eh-features__heading-G0m4e {
  font-family: inherit;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  color: #003453;
  text-align: center;
  margin: 0 0 68px 0;
}

.Featurecard-eh-features__grid-HBaOA {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
}

.Featurecard-eh-card-YKepk {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  background: rgba(171, 228, 255, 0.4);
  border: 1px solid #009cff;
  border-radius: 19px;
  padding: 40px 30px 36px 30px;
  min-height: 341px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  text-align: center;
  position: relative;
  -webkit-transition: -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  transition: transform 0.2s ease, box-shadow 0.2s ease, -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
}

.Featurecard-eh-card-YKepk:hover {
  -webkit-transform: translateY(-3px);
      -ms-transform: translateY(-3px);
          transform: translateY(-3px);
  -webkit-box-shadow: 0 10px 28px rgba(0, 52, 83, 0.08);
          box-shadow: 0 10px 28px rgba(0, 52, 83, 0.08);
}

.Featurecard-eh-card__icon-badge-ErJbv {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 79px;
  height: 79px;
  background: #ffffff;
  border-radius: 39.5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 24px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -webkit-box-shadow: 0 2px 8px rgba(0, 52, 83, 0.04);
          box-shadow: 0 2px 8px rgba(0, 52, 83, 0.04);
}

.Featurecard-eh-card__percent-badge-jJrQo {
  font-family: inherit;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #00c987;
  text-align: center;
}

.Featurecard-eh-card__title-i0n_5 {
  font-family: inherit;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  color: #003453;
  text-align: center;
  margin: 0 0 18px 0;
}

.Featurecard-eh-card__desc-XmI3b {
  font-family: inherit;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  color: #003453;
  text-align: center;
  margin: 0;
  max-width: 400px;
}

/* Mascot on third card */

.Featurecard-eh-card--with-mascot-ppmOm {
  overflow: visible;
}

.Featurecard-eh-card__mascot-wrapper-d6TX6 {
  position: absolute;
  top: -50px;
  left: -35px;
  width: 145px;
  height: 156px;
  pointer-events: none;
  z-index: 2;
}

.Featurecard-eh-card__mascot-img-Apx_T {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

@media (max-width: 1200px) {
  .Featurecard-eh-features__grid-HBaOA {
    gap: 24px;
  }
  .Featurecard-eh-card-YKepk {
    padding: 36px 20px 32px 20px;
  }
  .Featurecard-eh-card__title-i0n_5 {
    font-size: 28px;
    line-height: 34px;
  }
  .Featurecard-eh-card__desc-XmI3b {
    font-size: 19px;
    line-height: 27px;
  }
  .Featurecard-eh-card__mascot-wrapper-d6TX6 {
    top: -68px;
    left: 4px;
    width: 125px;
    height: 135px;
  }
}

@media (max-width: 900px) {
  .Featurecard-eh-features-QcEOS {
    padding: 36px 16px 56px;
  }
  .Featurecard-eh-features__container-tfAbN {
    padding: 0 8px;
  }
  .Featurecard-eh-features__grid-HBaOA {
    grid-template-columns: 1fr;
    max-width: 480px;
    margin: 0 auto;
    gap: 56px;
  }
  .Featurecard-eh-features__heading-G0m4e {
    font-size: 28px;
    margin-bottom: 50px;
  }
  .Featurecard-eh-card-YKepk {
    padding: 36px 24px 32px;
    min-height: auto;
  }
  .Featurecard-eh-card__title-i0n_5 {
    font-size: 28px;
    line-height: 34px;
  }
  .Featurecard-eh-card__desc-XmI3b {
    font-size: 20px;
    line-height: 28px;
  }
  .Featurecard-eh-card__mascot-wrapper-d6TX6 {
    top: -72px;
    left: 8px;
    width: 130px;
    height: 140px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/Featurecard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;AACtB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6EAAqD;EAArD,qEAAqD;EAArD,qDAAqD;EAArD,gHAAqD;AACvD;;AAEA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qDAA6C;UAA7C,6CAA6C;AAC/C;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAc;MAAd,cAAc;EACd,mDAA2C;UAA3C,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB;;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".eh-features {\n  width: 100%;\n  background: #ffffff;\n  padding: 48px 60px 72px;\n}\n\n.eh-features__container {\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.eh-features__heading {\n  font-family: inherit;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #003453;\n  text-align: center;\n  margin: 0 0 68px 0;\n}\n\n.eh-features__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 60px;\n  align-items: stretch;\n}\n\n.eh-card {\n  box-sizing: border-box;\n  background: rgba(171, 228, 255, 0.4);\n  border: 1px solid #009cff;\n  border-radius: 19px;\n  padding: 40px 30px 36px 30px;\n  min-height: 341px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.eh-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 28px rgba(0, 52, 83, 0.08);\n}\n\n.eh-card__icon-badge {\n  box-sizing: border-box;\n  width: 79px;\n  height: 79px;\n  background: #ffffff;\n  border-radius: 39.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 52, 83, 0.04);\n}\n\n.eh-card__percent-badge {\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #00c987;\n  text-align: center;\n}\n\n.eh-card__title {\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 38px;\n  color: #003453;\n  text-align: center;\n  margin: 0 0 18px 0;\n}\n\n.eh-card__desc {\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 30px;\n  color: #003453;\n  text-align: center;\n  margin: 0;\n  max-width: 400px;\n}\n\n/* Mascot on third card */\n.eh-card--with-mascot {\n  overflow: visible;\n}\n\n.eh-card__mascot-wrapper {\n  position: absolute;\n  top: -50px;\n  left: -35px;\n  width: 145px;\n  height: 156px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.eh-card__mascot-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@media (max-width: 1200px) {\n  .eh-features__grid {\n    gap: 24px;\n  }\n  .eh-card {\n    padding: 36px 20px 32px 20px;\n  }\n  .eh-card__title {\n    font-size: 28px;\n    line-height: 34px;\n  }\n  .eh-card__desc {\n    font-size: 19px;\n    line-height: 27px;\n  }\n  .eh-card__mascot-wrapper {\n    top: -68px;\n    left: 4px;\n    width: 125px;\n    height: 135px;\n  }\n}\n\n@media (max-width: 900px) {\n  .eh-features {\n    padding: 36px 16px 56px;\n  }\n  .eh-features__container {\n    padding: 0 8px;\n  }\n  .eh-features__grid {\n    grid-template-columns: 1fr;\n    max-width: 480px;\n    margin: 0 auto;\n    gap: 56px;\n  }\n  .eh-features__heading {\n    font-size: 28px;\n    margin-bottom: 50px;\n  }\n  .eh-card {\n    padding: 36px 24px 32px;\n    min-height: auto;\n  }\n  .eh-card__title {\n    font-size: 28px;\n    line-height: 34px;\n  }\n  .eh-card__desc {\n    font-size: 20px;\n    line-height: 28px;\n  }\n  .eh-card__mascot-wrapper {\n    top: -72px;\n    left: 8px;\n    width: 130px;\n    height: 140px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-features": `Featurecard-eh-features-QcEOS`,
	"eh-features__container": `Featurecard-eh-features__container-tfAbN`,
	"eh-features__heading": `Featurecard-eh-features__heading-G0m4e`,
	"eh-features__grid": `Featurecard-eh-features__grid-HBaOA`,
	"eh-card": `Featurecard-eh-card-YKepk`,
	"eh-card__icon-badge": `Featurecard-eh-card__icon-badge-ErJbv`,
	"eh-card__percent-badge": `Featurecard-eh-card__percent-badge-jJrQo`,
	"eh-card__title": `Featurecard-eh-card__title-i0n_5`,
	"eh-card__desc": `Featurecard-eh-card__desc-XmI3b`,
	"eh-card--with-mascot": `Featurecard-eh-card--with-mascot-ppmOm`,
	"eh-card__mascot-wrapper": `Featurecard-eh-card__mascot-wrapper-d6TX6`,
	"eh-card__mascot-img": `Featurecard-eh-card__mascot-img-Apx_T`
};
module.exports = ___CSS_LOADER_EXPORT___;
